<template>
    <v-container fluid>
        <v-row class="mt-6 ml-6">
            <v-text-field v-model="search_text" label="搜尋" class="input_600 ml-3" append-icon="mdi-magnify" outlined></v-text-field>
            <!-- <v-btn large color="success" class="ml-3 mt-1" style="height: 46px; font-size: 18px;">搜尋</v-btn> -->
        </v-row>

        <v-row class="ml-6 mr-6">
            <v-col cols="12" sm="12">
                <v-data-table :headers="headers" :items="table_data" :search="search_text"  class="elevation-1">
                    <template v-slot:item.index="{ item }">
                        {{table_data.findIndex(e=>e.patient_code==item.patient_code)+1}}
                    </template>

                    <!--<template v-slot:item.tags="{item}">
                        <!-- {{item.tags}} -->
                        <!--<v-chip v-for="tag in item.tags" :key="tag.user_tag_id" class="ma-2">{{tag.title}}</v-chip>
                    </template>-->
                    <template v-slot:item.set="{item}">
                        <v-btn @click="check_patient(item)" class="ml-3" color="success">查看</v-btn>
                        <v-btn @click="open_send(item)" class="ml-3" color="primary" :disabled="!item.link_check">傳送訊息</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog v-model="push_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">傳送訊息
                    <v-spacer/>
                    <v-icon @click="push_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <v-row>
                        <v-textarea v-model="msg" no-resize outlined  label="輸入您要傳送的訊息"></v-textarea>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="submit(); push_dialog = false" block>送出</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import bus from '../nav/bus'
var host_url = process.env.VUE_APP_HOST_URL

export default {
    props:{
        vendor_id: {
            type: Number,
            default: -1
        }
    },
    data(){
        return {
            search_text: "",
            page: 0,
            push_dialog: false,
            msg: "",

            headers: [
                {text: '編號', align: 'center', value: 'index', width: 60, sortable: false},
                {text: '病歷號碼', align: 'center', value: 'patient_code', width: 360},
                {text: '填寫數量', align: 'center', value: 'success_num', width: 120},
                //{text: '標籤', align: 'center', value: 'tags', sortable: false},
                {text: '操作', align: 'center', value: 'set', width: 240, sortable: false},
            ],
            table_data: [],

            send_data: {

                patient_code: '',
            },
            info: {},
            page: 0,
        }
    },
    created(){
        this.get_patient()
    },
    methods:{
        init_send_data(){
            this.send_data = null
        },
        init_msg(){
            this.msg = ''
        },
        get_patient(){
            console.log(host_url)
            axios.get(host_url+'patient_list/')
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.table_data;
                    console.log(this.table_data)
                }
            })
            .catch((error) =>{
                // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                console.log(error);
            });
        },
        deleted_tag(item, tag){
            item.tags.splice(item.tags.indexOf(tag), 1)
        },
        edit_doctor_click(){
            this.doctor_dialog = true
        },
        open_send(val){
            this.msg = ''
            this.push_dialog=true
            this.send_data.patient_code = val.patient_code
            this.info = val
        },
        submit(){
            console.log(this.send_data)
            if(this.msg == ''){
                bus.$emit('alert', {msg: "訊息不能為空白!", title: "錯誤提示",　check: "我知道了"})
                return
            }
            let data = {
                patient_code: this.send_data.patient_code,
                info: this.info,
                message: this.msg,
            }
            axios.post(host_url+'send_individual/', {"data": data})
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error) =>{
                // this.$ga.event('liff_manage', 'getliffevent', 'Error')
                console.log(error);
            });
        },
        check_patient(item){
            localStorage.setItem('patient_code', item.patient_code)
            this.$router.push('/patient_show')
        },

    }
}
</script>

<style lang="scss" scoped>

::v-deep .input_600{
    max-width: 600px;
}

</style>
